import { useState } from "react";
import ToggleButton from "../../components/buttons/ToggleButton";
import ToggleGroup from "../../components/buttons/ToggleGroup";
import { ReactComponent as DisabledSVG } from "../../icons/icon_files/risk_accepted.svg";
import { ReactComponent as CardViewSVG } from "../../scenes/stack/environment/icons/card_view_24.svg";
import { ReactComponent as TableViewSVG } from "../../scenes/stack/environment/icons/table_view_24.svg";

const option = {
  FIRST: "First",
  SECOND: "Second",
  DISABLED: "Disabled",
};

export default function ToggleGroupDemo() {
  const [selected, setSelected] = useState(option.FIRST);

  return (
    <ToggleGroup>
      <ToggleButton
        iconSVG={CardViewSVG}
        selected={selected === option.FIRST}
        onClick={() => {
          setSelected(option.FIRST);
        }}
        disabled={false}
      >
        {option.FIRST}
      </ToggleButton>
      <ToggleButton
        iconSVG={TableViewSVG}
        selected={selected === option.SECOND}
        onClick={() => {
          setSelected(option.SECOND);
        }}
        disabled={false}
      >
        {option.SECOND}
      </ToggleButton>
      <ToggleButton
        iconSVG={DisabledSVG}
        selected={selected === option.DISABLED}
        onClick={() => {
          setSelected(option.DISABLED);
        }}
        disabled={true}
      >
        {option.DISABLED}
      </ToggleButton>
    </ToggleGroup>
  );
}
